const AdminPanel = () => {
    return(
        <h1>AdminPanel</h1>
    );
}

export default AdminPanel;